/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (locationGroups) => ({
    type: actions.LOCATION_GROUPS_RECEIVE,
    payload: { locationGroups },
});